import { TrackThumbnail, TrackItem } from '../../remotion-tracks';
import { ThumbnailType } from '@monorepo/types';
import TiktokThumbnail from './thumbnail-types/tiktok-thumbnail';
import { FunctionComponent } from 'react';
import TextThumbnail from './thumbnail-types/text-thumbnail';

const Thumbnails: FunctionComponent<{
  item: TrackItem;
}> = ({ item }) => {
  const thumbnailData = item.data as TrackThumbnail;

  if (thumbnailData.type === ThumbnailType.TikTok) {
    return <TiktokThumbnail data={thumbnailData} />;
  }
  if (thumbnailData.type === ThumbnailType.Text) {
    return <TextThumbnail data={thumbnailData} />;
  }

  return null;
};

export default Thumbnails;
